import { useContext } from 'react'
import BarcodeScannerContext from './BarcodeScannerContext'

const useDynamicSoftScanner = () => {
    return useContext(BarcodeScannerContext)
}

export default useDynamicSoftScanner
